export enum TransactionMethod {
  CREDIT_CARD = 'creditCard',
  CASH = 'cash',
  CHECK = 'check',
  APPLE_PAY = 'applePay',
  GOOGLE_PAY = 'googlePay',
  PATIENT_IVR = 'ivr',
  STAFF_CREDIT_CARD = 'staffCreditCard',
}
